import { render, staticRenderFns } from "./sales-order-edit.vue?vue&type=template&id=0e3c5f40&scoped=true&"
import script from "./js/sales-order-edit.js?vue&type=script&lang=js&"
export * from "./js/sales-order-edit.js?vue&type=script&lang=js&"
import style0 from "./sales-order-edit.vue?vue&type=style&index=0&id=0e3c5f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c5f40",
  null
  
)

export default component.exports